import i18n from '@/utils/i18n';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Routes } from '@/utils/routes';

const Forbidden = () => {
  const history = useHistory();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <FaExclamationTriangle
          className="me-2"
          style={{ fontSize: '3rem', color: '#FFA500' }}
        />
        <h1 style={{ fontSize: '3rem' }}>{i18n.t('Common:forbidden')}</h1>
        <FaExclamationTriangle
          className="ms-2"
          style={{ fontSize: '3rem', color: '#FFA500' }}
        />
      </div>
      <p>{i18n.t('Common:forbiddenText')}</p>
      <Button className="tw:mt-4" onClick={() => history.push(Routes.home())}>
        {i18n.t('Common:backToHome')}
      </Button>
    </div>
  );
};

export default Forbidden;
